import { Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { statusLabel } from "@/lib/order";
import { cn } from "@/lib/utils";

const TONE = {
  PENDING: "bg-[hsl(var(--warning))]/20 text-[hsl(27_60%_32%)] border-transparent",
  DELIVERED: "bg-[hsl(var(--success))]/15 text-[hsl(var(--success))] border-transparent",
  CANCELLED: "bg-destructive/10 text-destructive border-transparent",
  REFUNDED: "bg-destructive/10 text-destructive border-transparent",
};

export function StatusBadge({ status, className }) {
  const tone = TONE[status] || "bg-primary/10 text-primary border-transparent";
  return (
    <Badge className={cn("rounded-full font-normal", tone, className)} data-testid={`status-badge-${status}`}>
      {statusLabel(status)}
    </Badge>
  );
}

export function StatusTimeline({ steps, current, history = {} }) {
  const idx = steps.indexOf(current);
  return (
    <ol className="space-y-4" data-testid="status-timeline">
      {steps.map((s, i) => {
        const done = i < idx || current === "DELIVERED";
        const active = i === idx;
        return (
          <li key={s} className="flex items-start gap-3">
            <span
              className={cn(
                "mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 text-[11px]",
                done && "border-[hsl(var(--success))] bg-[hsl(var(--success))] text-white",
                active && !done && "border-primary bg-primary text-white",
                !done && !active && "border-border bg-card text-muted-foreground",
              )}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </span>
            <div className="pt-0.5">
              <p className={cn("text-sm", active ? "text-foreground" : "text-muted-foreground")}>
                {statusLabel(s)}
              </p>
              {history[s] && (
                <p className="text-xs text-muted-foreground">
                  {new Date(history[s]).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
